import { AdminDeliverysTemplate } from "../../Templates/AdminDeliverysTemplate";

export const AdminDeliverys = () => {
  return <AdminDeliverysTemplate />;
};
